export const STYLES: any = {
	FULLSCREEN: {
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		position: 'absolute',
	},
}
